const l = [
  {
    url: "aa/aa.svg",
    print: "አ",
    letterIndex: 0,
    vindex: 0,
    sound: "aa/aa.mp3",
  },

  {
    url: "aa/aau.svg",
    print: "ኡ",
    letterIndex: 0,
    vindex: 1,
    sound: "aa/aau.mp3",
  },

  {
    url: "aa/aai.svg",
    print: "ኢ",
    letterIndex: 0,
    vindex: 2,
    sound: "aa/aai.mp3",
  },

  {
    url: "aa/aaa.svg",
    print: "ኣ",
    letterIndex: 0,
    vindex: 3,
    sound: "aa/aa.mp3",
  },

  {
    url: "aa/aay.svg",
    print: "ኤ",
    letterIndex: 0,
    vindex: 4,
    sound: "aa/aay.mp3",
  },

  {
    url: "aa/aeu.svg",
    print: "እ",
    letterIndex: 0,
    vindex: 5,
    sound: "aa/aeu.mp3",
  },

  {
    url: "aa/aao.svg",
    print: "ኦ",
    letterIndex: 0,
    vindex: 6,
    sound: "aa/aao.mp3",
  },
];

export default l;
